module.exports = __webpack_public_path__ + "static/img/yytx29.402d0d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx29.png
// module id = 897
// module chunks = 0